"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ethParameterToDumbappValue = ethParameterToDumbappValue;
exports.ethParametersToDumbappValues = ethParametersToDumbappValues;
exports.getFeatures = getFeatures;
exports.getFieldType = getFieldType;
exports.hasFunction = hasFunction;
exports.isContractStep = isContractStep;
exports.isDumbappSource = isDumbappSource;
exports.isDumbappValue = isDumbappValue;
exports.isEtherStep = isEtherStep;
exports.solidityTypeToArgumentType = solidityTypeToArgumentType;
var _ethTypes = require("@blockwell/eth-types");
var _apiminerClient = require("@blockwell/apiminer-client");
function solidityTypeToArgumentType(input) {
  switch (input) {
    case "fixed":
    case "ufixed":
    case "int":
    case "uint":
    case "bool":
    case "address":
    case "bytes":
    case "string":
    case "tuple":
      return input;
    case "function":
    case "any":
      return "string";
    default:
      return "string";
  }
}
function isDumbappSource(it) {
  if (it && typeof it === "object") {
    return typeof it.type === "string" && typeof it.parameters === "object";
  }
  return false;
}
function isDumbappValue(it) {
  if (Array.isArray(it)) {
    for (let ele of it) {
      if (!isDumbappValue(ele)) {
        return false;
      }
    }
    return true;
  }
  let type = typeof it;
  if (it && type === 'object') {
    for (let val of Object.values(it)) {
      if (!isDumbappValue(val)) {
        return false;
      }
    }
    return true;
  }
  return type === "string" || type === "boolean" || type === "number";
}
function ethParametersToDumbappValues(params) {
  let data = {};
  for (let param of params) {
    if (param.name) {
      data[param.name] = ethParameterToDumbappValue(param);
    }
  }
  return data;
}
function ethParameterToDumbappValue(param) {
  if ((0, _ethTypes.isTupleParameter)(param)) {
    return ethParametersToDumbappValues(param.components);
  }
  if ((0, _ethTypes.isTupleArrayParameter)(param)) {
    return param.values.map(it => ethParametersToDumbappValues(it.components));
  }
  if ((0, _ethTypes.isStringArrayParameter)(param) || (0, _ethTypes.isBooleanArrayParameter)(param)) {
    return param.values;
  }
  if ((0, _ethTypes.isIndexedParameter)(param)) {
    return param.hash;
  }
  return param.value;
}
function isEtherStep(it) {
  return it && "ether" in it;
}
function isContractStep(it) {
  return it && "method" in it;
}
function getFieldType(name, typing, func = null, i = 0) {
  let type;
  if (typing.name === "uint" && (name === 'unlockTime' || name === 'lockTime' || name === 'stakeTime')) {
    type = 'time';
  } else if (typing.name === "uint" && name === 'proposalId') {
    type = 'payment-proposal';
  } else if ((func === null || func === void 0 ? void 0 : func.name) === "vote" && func.inputs.length === 2 && i === 0) {
    type = 'suggestion';
  } else if ((func === null || func === void 0 ? void 0 : func.name) === "multiVote" && func.inputs.length === 3 && i === 0) {
    type = 'suggestion';
  } else if ((func === null || func === void 0 ? void 0 : func.name) === "proposalVote" && func.inputs.length === 2 && i === 0) {
    type = 'proposal';
  } else if (typing.name === "function" || typing.name === "any") {
    type = "string";
  } else {
    type = typing.name;
  }
  return type;
}
function getFeatures(contract) {
  if (contract.bwtype) {
    let bwType = _apiminerClient.bwTypeMap[contract.bwtype];
    if (bwType.features) {
      return bwType.features;
    }
  }
  let features = [];
  let funcs = contract.abi.filter(it => it.type === 'function');
  if (hasFunction(funcs, 'safeTransferFrom', 'address', 'address', 'uint256') && hasFunction(funcs, 'safeTransferFrom', 'address', 'address', 'uint256', 'bytes') && hasFunction(funcs, 'balanceOf', 'address') && hasFunction(funcs, 'ownerOf', 'uint256') && hasFunction(funcs, 'approve', 'address', 'uint256') && hasFunction(funcs, 'setApprovalForAll', 'address', 'bool')) {
    features.push('erc721');
  } else if (hasFunction(funcs, 'transfer', 'address', 'uint256') && hasFunction(funcs, 'approve', 'address', 'uint256') && hasFunction(funcs, 'transferFrom', 'address', 'address', 'uint256')) {
    features.push('erc20');
  }
  return features;
}
function hasFunction(abi, name, ...params) {
  return !!abi.find(it => {
    var _it$inputs;
    if (it.name !== name) {
      return false;
    }
    if (((_it$inputs = it.inputs) === null || _it$inputs === void 0 ? void 0 : _it$inputs.length) !== params.length) {
      return false;
    }
    let i = 0;
    for (let input of it.inputs) {
      let paramType = _ethTypes.Typing.parse(params[i]);
      let inputType = _ethTypes.Typing.parse(input.type);
      if (!paramType.equals(inputType)) {
        return false;
      }
      ++i;
    }
    return true;
  });
}
//# sourceMappingURL=util.js.map